import React, { FC, ReactNode } from 'react'
import { Button, Typography } from '@mui/material'

import { DialogShell } from './DialogShell'
import { PORTAL_TEXT } from '@/apps/latest/shared/styles/portalTypography'

// Notion 流 confirm dialog. window.confirm のブラウザネイティブ chrome を排し、
// portal の他 modal と統一. variant='danger' で破壊操作 (= 削除/破棄) を赤字に.
interface ConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: ReactNode
  /** 本文. 文字列なら 13/secondary で render. ReactNode なら caller 任意 */
  message: ReactNode
  /** 確定ボタンの label. default '確定' */
  confirmLabel?: string
  /** キャンセルボタンの label. default 'キャンセル' */
  cancelLabel?: string
  /** 'danger' で confirm button が error 色. 削除/破棄 op で使用 */
  variant?: 'default' | 'danger'
  /** submit 中の操作禁止 */
  disabled?: boolean
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = '確定',
  cancelLabel = 'キャンセル',
  variant = 'default',
  disabled,
}) => (
  <DialogShell
    open={open}
    onClose={onClose}
    title={title}
    disabled={disabled}
    maxWidth="xs"
    actions={
      <>
        <Button onClick={onClose} disabled={disabled} color="inherit">
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={disabled}
          color={variant === 'danger' ? 'error' : 'primary'}
          variant="contained"
          autoFocus
        >
          {confirmLabel}
        </Button>
      </>
    }
  >
    {typeof message === 'string' ? (
      <Typography sx={PORTAL_TEXT.cellSecondary}>{message}</Typography>
    ) : (
      message
    )}
  </DialogShell>
)
